var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8834 9.11719C12.7584 10.9922 12.7584 14.0255 10.8834 15.8922C9.00845 17.7589 5.97512 17.7672 4.10845 15.8922C2.24178 14.0172 2.23345 10.9839 4.10845 9.11719",
    stroke: "#0158E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82505 11.1754C6.87505 9.22539 6.87505 6.05873 8.82505 4.10039C10.775 2.14206 13.9417 2.15039 15.9001 4.10039C17.8584 6.05039 17.8501 9.21706 15.9001 11.1754",
    stroke: "#0158E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.facb7c4ee910b6e605ea2b9d35d4e083.svg";
export { ForwardRef as ReactComponent };